import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

// Components
import DynamicTable from "../../../components/DynamicTable";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
// Material UI Component
import {
  FormGroup,
  FormLabel,
  FormControl,
  // ListItemText,
  TextField,
  // Checkbox,
  // FormControlLabel,
  Grid,
  Select,
  InputLabel,
  Input,
  // MenuItem,
  Modal,
  Backdrop,
  Fade,
  FormHelperText,
  NativeSelect,
  Button,
  Breadcrumbs,
  Typography,
} from "@material-ui/core";
import {
  makeStyles,
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";

//cookies
import { get_cookies } from "../../../components/Cookies/Cookies";
import numeral from "numeral";
import MessageBox from "../../../components/MessageBox/MessageBox";
import { checkDateRange } from "../../../services/utils";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const SalesOrderHistory = () => {
  const refDataFilter = React.createRef();

  const [posts, setPosts] = useState(null);
  const [open, setOpen] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: addDays(new Date(), 7),
  });

  const [checkMaxDays, setCheckMaxDays] = useState(false);

  // const useridNo = get_cookies('branchidno');

  const classes = useStyles();

  const [useridNo, setuseridNo] = useState(get_cookies("branchidno"));

  const url = "so_transaction_history";

  const onFetchedApi = () => {
    refDataFilter.current.onFetchApi();
  };

  // Data Fetching
  useEffect(() => {
    onFetchedApi();
  }, []);

  //search button
  // const dataFilter = async () => {
  // 	setDataLoaded(false);
  //     await axios.get(
  // 		process.env.REACT_APP_API_URL+'so_transaction_history', {
  //         params:{
  //             date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
  //             date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
  //             jc_user_id_no: useridNo,
  //         }
  //     }).then((res)=>{
  // 		setPosts(res.data.data);
  // 	}).catch((error)=>{
  // 		console.log(error.message);
  // 	})
  // 	setDataLoaded(true);
  // }

  // const data = async () => {
  // 	setDataLoaded(true);
  // };

  const toggle = () => setOpen(!open);

  // const handleModalOpen = () => {
  // 	setModalOpen(true);
  // };

  // const handleModalClose = () => {
  // 	setModalOpen(false);
  // };

  const dateRangeHandler = (range) => {
    if (checkDateRange(range.endDate, range.startDate) <= 30) {
      setDateRange(range);
    } else {
      setCheckMaxDays(true);
      setTimeout(() => {
        setCheckMaxDays(false);
      }, 6000);
    }
    setOpen(false);
  };

  const columns = [
    {
      name: "date",
      label: "Date",
    },
    {
      name: "sono",
      label: "Sono",
    },
    {
      name: "name",
      label: "Name",
    },
    {
      name: "amount",
      label: "Amount",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ textAlign: "right" }}>
              {numeral(value).format("0,0.00")}
            </div>
          );
        },
      },
    },
    {
      name: "shipping",
      label: "Shipping",
    },
    {
      name: "classification",
      label: "Classification",
    },
    {
      name: "status",
      label: "Status",
    },
    {
      name: "action",
      label: "Action",
      options: {
        sort: false,
        filter: false,
        download: false, //exclude this column in csv export
        customBodyRenderLite: (dataIndex) => {
          let sono = posts[dataIndex].sono;
          //salesorderviewreference
          //salesorderviewdetails
          return (
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <NavLink
                  to={
                    "/sales/sales-order-history-view-ref/" +
                    sono +
                    "/" +
                    useridNo
                  }
                >
                  <Button variant="contained" color="primary">
                    View Reference
                  </Button>
                </NavLink>
              </Grid>

              {/* temporary hide ask per request */}
              {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<NavLink to={"/sales/sales-order-history-view-details/"+sono+"/"+useridNo}>
										<Button variant="contained" color="primary"> 
											View Details
										</Button>	
									</NavLink> 	
								</Grid> */}
            </Grid>
          );
        },
      },
    },
  ];

  // const options = {
  // 	filter: true,
  // 	// filterType: "dropdown",
  // 	selectableRows: "none",
  // 	filterType: "multiselect",
  // 	responsive: "standard",
  // 	setFilterChipProps: (colIndex, colName, data) => {
  // 		//console.log(colIndex, colName, data);
  // 		return {
  // 			color: "primary",
  // 			variant: "outlined",
  // 			className: "testClass123",
  // 		};
  // 	},
  // 	download: downloadFlag,  //add this
  // 	print: downloadFlag, //add this
  // 	downloadOptions: {
  // 		filename : 'SalesOrderHistory.csv' //change filename of csv
  // 	}
  // 	// tableBodyHeight,
  // };

  const style = {
    marginBottom: "1rem",
    marginTop: "2.5em",
  };

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <ShoppingCartIcon />
        </div>
        <Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/sales">
						<h2 className="header-title">Sales</h2>
					</NavLink>
					<Typography color="textPrimary">Sales Order Transaction History</Typography>
				</Breadcrumbs>
      </div>
      <div className="page-container">
        <div style={style}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
              <TextField
                id="outlined-basic"
                label="Select Date"
                variant="outlined"
                onFocus={() => setOpen(true)}
                fullWidth={true}
                autoComplete="off"
                value={`${format(dateRange.startDate, "MM/dd/yyyy")} - ${format(
                  dateRange.endDate,
                  "MM/dd/yyyy"
                )}`}
              />
              <DateRangePicker
                open={open}
                toggle={toggle}
                onChange={(range) => dateRangeHandler(range)}
              />
            </Grid>
            <Grid item xs={1} lg={1} xl={1}>
              <Button
                style={{ marginTop: "22px" }}
                variant="contained"
                color="primary"
                onClick={() => {
                  onFetchedApi();
                }}
              >
                Search
              </Button>
            </Grid>
          </Grid>
        </div>

        <DynamicTable
          title="Sales Order History"
          columns={columns}
          rows={posts}
          setRows={setPosts}
          ref={refDataFilter}
          dateRange={dateRange}
          url={url}
        />
      </div>

      <MessageBox
        in={checkMaxDays}
        content="Maximum of 30 days date range. Kindly select again."
        type="warning"
      />
    </div>
  );
};

export default SalesOrderHistory;
